// extracted by mini-css-extract-plugin
export default {"spinner":"spinner--yVme3","rotate":"rotate--AEAnz","link":"link--pXJGX","icon":"icon--X68sG","iconWithCaption":"iconWithCaption--xQskC","caption":"caption--utwZI"};